module.exports = __webpack_public_path__ + "img/dashboard.f5e178c8.svg";